import {
    openapiProxySessionProgramLoginRequest,
    OpenapiProxySessionProgramLoginResponse200Type,
} from 'src_common/server/openapi_proxy_session_program_login';

export const createProgramSession = async (
    API_URL: string,
    API_TIMEOUT: number,
    API_USER: string,
    API_PASSWORD: string
): Promise<null | OpenapiProxySessionProgramLoginResponse200Type> => {
    const response = await openapiProxySessionProgramLoginRequest(API_URL, API_TIMEOUT, 'kopytko', {
        requestBody: {
            username: API_USER,
            password: API_PASSWORD,
        },
    });

    if (response.status === 200) {
        return response.body;
    }

    console.error('Errors when creating an program session', response);

    return null;
};
